export default __webpack_public_path__ + "static/media/img-0716-estonia-full-face.d6c483ec.png";